<template>
  <div class="modify-pwd-container">
    <div class="box">
      <div class="box-left"></div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="left">
        <h3 class="title">找回密码</h3>
        <el-form-item prop="username">
          <el-input v-model="loginForm.userName" placeholder="账号" name="username" type="text"/>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="新密码" name="password"/>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input v-model="loginForm.confirmPassword" type="password" placeholder="确认密码" name="confirmPassword"/>
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input v-model="loginForm.mobile" placeholder="手机号" name="mobile" type="text"/>
        </el-form-item>
        <el-form-item prop="vecode" class="code">
          <el-input class="ver-input" v-model="loginForm.vecode" placeholder="验证码" name="vecode" type="text"/>
          <el-link :underline='false' class="ver" :disabled="disabledCodeBtn" @click="doSendCode" v-if="!isCountDown">
            获取验证码
          </el-link>
          <div class="count-down ver" v-else>{{ countDownNumber }}s</div>
        </el-form-item>
        <el-button class="btn" :disabled="disabledSubmitBtn" :loading="loading" @click.native.prevent="doModifyPwd">确定
        </el-button>
        <!-- <div class="tips">收不到验证码，请拨打4008858821</div> -->
      </el-form>
    </div>
    <code-img :value.sync="codeForm" :visible.sync="codeImgVisible" @submit="handleCaptchaSubmit"></code-img>
  </div>
</template>

<script>
import {
  sendVecode, UserModifyPassword, filterUser,
} from "@/api/login";
import { userLoginError, validStrictPsd, strictPsdError } from '@/utils';
import codeImg from '@/components/codeImg/index.vue';

export default {
  name: "forgetPwd",
  components: {
    codeImg,
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
      callback();
    };
    const validateSmsCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (validStrictPsd(value)) {
        callback();
      } else {
        callback(new Error(strictPsdError));
      }
    };
    const validateConfirmPassword = (rule, value, callback) => {
      if (!validStrictPsd(value)) {
        callback(new Error(strictPsdError));
      } else if (value !== this.loginForm.password) {
        callback(new Error("密码和确认密码必须一致"));
      } else {
        callback();
      }
    };
    return {
      isCountDown: false,
      countDownNumber: 60,
      codeImgVisible: false,
      loginForm: {
        userName: "",
        mobile: "",
        vecode: "",
        vecodekey: '',
        password: "",
        confirmPassword: "",
      },
      loginRules: {
        userName: [{ required: true, trigger: "blur", validator: validateUsername }],
        mobile: [{ required: true, trigger: "blur", validator: validateMobile }],
        vecode: [{ required: true, trigger: "blur", validator: validateSmsCode }],
        password: [{ required: true, trigger: "blur", validator: validatePassword }],
        confirmPassword: [{ required: true, trigger: "blur", validator: validateConfirmPassword }],
      },
      codeForm: {
        code: "",
        sess: "",
      },
      codeRules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      loading: false,
      timer: null,
      isNeedSecondCaptcha: false,
    };
  },
  computed: {
    disabledSubmitBtn() {
      return !(
        this.loginForm.userName
        && this.loginForm.password.length >= 8
        && this.loginForm.password.length <= 16
        && this.loginForm.vecode
        && this.loginForm.password === this.loginForm.confirmPassword
      );
    },
    disabledCodeBtn() {
      return !(this.loginForm.userName && this.loginForm.mobile);
    },
  },
  methods: {
    doSendCode() {
      if (this.isCountDown) return;
      if (!this.loginForm.mobile || this.loginForm.mobile.length !== 11) {
        this.$message.warning('请先输入11位手机号');
        return;
      }
      this.sendPhoneCode();
    },
    handleCaptchaSubmit() {
      if (this.isNeedSecondCaptcha) {
        this.isNeedSecondCaptcha = false;
        this.codeImgVisible = false;
        this.doModifyPwd();
        return;
      }
      this.isNeedSecondCaptcha = true;
      this.sendPhoneCode();
    },
    sendPhoneCode() {
      const params = {
        addressType: 2, // 验证码类型2为手机号，3为邮箱
        vecodeType: 3, // 验证码类型：重置密码
        address: this.loginForm.mobile,
        captcha: this.codeForm.code,
        captchaKey: this.codeForm.sess,
      };
      this.codeLoading = true;
      sendVecode(params).then((res) => {
        this.codeForm.code = '';
        this.codeForm.sess = '';
        this.codeLoading = false;
        if (res.data.code === 0) {
          this.codeImgVisible = false;
          this.isCountDown = true;
          this.countDownNumber = 60;
          this.loginForm.vecodekey = res.data.key;
          this.$message.success("短信验证码已发送！");
          this.timer = setInterval(() => {
            if (this.countDownNumber < 1) {
              clearInterval(this.timer);
              this.countDownNumber = 60;
              this.isCountDown = false;
            } else {
              this.countDownNumber -= 1;
            }
          }, 1000);
        } else {
          this.showErrorMsg(res.data.code);
        }
      });
    },
    async doModifyPwd() {
      let isValid = true;
      this.$refs.loginForm.validate((valid) => {
        isValid = valid;
        return valid;
      });
      if (!isValid) return;
      this.loading = true;
      if (this.isNeedSecondCaptcha) {
        this.codeImgVisible = true;
        return;
      }
      let captchaParams = {};
      if (this.codeForm.code) {
        captchaParams = {
          captcha: this.codeForm.code,
          captchaKey: this.codeForm.sess,
        };
        this.codeForm.code = '';
        this.codeForm.sess = '';
      }
      // 第一步返回用户列表
      const firstRes = await this.forgetPassword({
        name: this.loginForm.mobile,
        pass: `${this.loginForm.vecodekey}|${this.loginForm.vecode}`,
        nameType: 2, // 1：用户名  2：手机号
        passType: 2, // 1：用户密码  2：验证码
        ...captchaParams,
      });
      const secondRes = (typeof firstRes === 'string' && await this.filterUser(firstRes)) || firstRes === true;
      if (typeof secondRes !== 'boolean' && !secondRes.hasName) {
        this.$message.error("手机号或账号填写有误，请检查！");
        this.loading = false;
        return;
      }
      // 请求业务线的过滤接口，返回用户列表，匹配一个用户名称
      const thirdRes = firstRes && secondRes && await this.forgetPassword({
        name: this.loginForm.userName,
        pass: `${this.loginForm.vecodekey}|${this.loginForm.vecode}`,
        nameType: 1, // 1：用户名  2：手机号
        passType: 2, // 1：用户密码  2：验证码
        new: (this.$md5(this.loginForm.password)).toUpperCase(),
        newType: 1, //  1：修改密码 （手机号对应单用户直接修改密码）
        ...captchaParams,
      });
      if (firstRes && secondRes && thirdRes) {
        this.$message.success("密码修改成功！");
        this.$router.push({ path: "/login" });
      }
      this.loading = false;
    },
    showErrorMsg(code) {
      const msg = userLoginError(code);
      this.$message.warning(msg);
      // 需要图形验证码, 图形验证码有误
      if ([10061, 10062, 10022, 10020].includes(code)) {
        this.codeImgVisible = true;
      }
    },
    forgetPassword(params) {
      return new Promise((resolve, reject) => {
        UserModifyPassword(params).then((response) => {
          const code = response.data.code;
          if (code === 0) {
            resolve(true);
          } else if (code === 10010) {
            // 10010表明请求成功返回加密串与业务后台换取用户列表
            resolve(response.data.filterUrl.replace('data=', ''));
          } else {
            this.showErrorMsg(code);
            resolve(false);
          }
        }).catch((e) => {
          reject(e);
        });
      });
    },
    filterUser(data) {
      return new Promise((resolve, reject) => {
        filterUser({
          data,
          userName: this.loginForm.userName,
        }).then((res) => {
          if (res.data.error_code === 0) {
            const nameList = res.data.data;
            const result = {
              hasName: nameList.includes(this.loginForm.userName),
            };
            resolve(result);
          } else {
            resolve(false);
          }
        }).catch((e) => {
          reject(e);
        });
      });
    },
  },
};
</script>

<style lang="scss">
.modify-pwd-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-image: url(../../assets/images/login/bg2.png);
  background-repeat: repeat-x;
  background-attachment: fixed;
  background-size: 100% 100%;

  .box {
    display: flex;
    width: 810px;
    height: 515px;
    background-color: #fff;
    border-radius: 8px;

    .box-left {
      width: 350px;
      background: url(../../assets/images/login/banner.png) no-repeat;
    }

    .login-form {
      width: 460px;
      padding: 0 60px;
      text-align: center;

      .el-form-item {
        margin: 0;
      }

      h3 {
        margin-top: 47px;
        font-size: 24px;
        font-weight: bold;
        color: #27364d;
      }

      .ver-input {
        .el-input__inner {
          padding-right: 90px;
        }
      }

      input {
        width: 100%;
        height: 30px;
        padding: 0;
        margin-top: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #27364d;
        background-color: #fff;
        border: 0;
        border-bottom: 1px solid #ddd;
        outline: 0;
        caret-color: #008cff;

        &:focus {
          border-bottom: 1px solid #008cff;
        }
      }

      .el-button {
        border: none;
      }

      input:-webkit-autofill {
        transition: background-color 5000s ease-in-out 0s;
      }

      .code {
        .el-form-item__content {
          input {
            position: relative;
          }

          .ver {
            position: absolute;
            right: 0;
            bottom: 10px;
            font-size: 16px;
            font-weight: 400;
            line-height: 27px;
            color: #0783ff;
          }
        }
      }

      .btn {
        width: 340px;
        height: 60px;
        margin-top: 21px;
        font-size: 20px;
        font-weight: 500;
        color: #eff4f8;
        background: linear-gradient(90deg, #51b2f7, #2d66f5);
        border-radius: 8px;
        box-shadow: 0 4px 8px 0 rgba(0, 140, 255, 0.2);
      }

      .tips {
        font-size: 16px;
        color: #666;
      }
    }
  }
}
</style>
